import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _get from 'lodash/get';

const Ad = ({
    adSlots,
    adUnit,
    targeting,
    pageTargeting,
    isOutOfPage,
    isResponsive,
    syncWithVideoAd,
}) => {
    
    const mappedAdSlots = adSlots && adSlots.map((adSlot) => {

        const adSlotContentId = _get(adSlot, 'contentId');
        const adSlotContainerId = adSlotContentId && `ad-${adSlotContentId}`;
        const adSlotBreakpoints = _get(adSlot, 'breakpoints');
        const adSlotDataSizes = !isOutOfPage ? _get(adSlot, 'sizes') : null;
        return (
            <div
                className={'ad-responsive-size'}
                id={adSlotContainerId}
                key={adSlotContainerId}
                data-syncwithvideoad={syncWithVideoAd}
                data-thresholds={adSlotBreakpoints && JSON.stringify(adSlotBreakpoints)}
                data-sizes={adSlotDataSizes && JSON.stringify(adSlotDataSizes)}
            ></div>
        );

    });

    const adClass = classNames({
        'p-ad': true,
        'ad-responsive-slot': isResponsive,
        'ad-outofpage': isOutOfPage,
    });

    return (
        <div
            className={adClass}
            data-adunit={adUnit}
            data-targeting={targeting && JSON.stringify(targeting)}
            data-page-targeting={pageTargeting && JSON.stringify(pageTargeting)}
        >
            {mappedAdSlots}
        </div>
    );

};

Ad.propTypes = {
    adSlots: PropTypes.arrayOf(
        PropTypes.shape({
            contentId: PropTypes.string,
            sizes: PropTypes.arrayOf(PropTypes.array),
            breakpoints: PropTypes.array,
        }),
    ),
    pageTargeting: PropTypes.shape(),
    targeting: PropTypes.shape(),
    adUnit: PropTypes.string,
    isOutOfPage: PropTypes.bool,
    isResponsive: PropTypes.bool,
    syncWithVideoAd: PropTypes.bool,
};

Ad.defaultProps = {
    pageTargeting: null,
    targeting: null,
    adUnit: null,
    isOutOfPage: false,
};

export default Ad;
